import React, { FC, memo } from 'react'
import { ETeacherCardsViews, ITeacherCard } from '../types'
import TeacherCardExtra from './TeacherCardExtra'
import TeacherCardHorizontal from './TeacherCardHorizontal'
import TeacherCardVertical from './TeacherCardVertical'

const TeacherCard: FC<ITeacherCard> = (props) => {
  const { view } = props

  switch (view) {
    case ETeacherCardsViews.extra:
      return <TeacherCardExtra {...props} />

    case ETeacherCardsViews.horizontal:
      return <TeacherCardHorizontal {...props} />

    default:
      return <TeacherCardVertical {...props} />
  }
}

export default memo(TeacherCard)
